<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "scroll-observer",
    props: {
        options: {
            type: Object,
            required: false,
            default: {},
        },
    },
    mounted() {
        this.options.default = {
            top: window.innerHeight || document.documentElement.clientHeight,
            bottom: 0,
            left: 0,
            right: window.innerWidth || document.documentElement.clientWidth,
        };

        document.addEventListener("scroll", this.handleScroll);
    },
    unmounted() {
        document.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            if (this.isInViewport()) {
                this.$emit("inViewport", this.$el.getBoundingClientRect());
            } else {
                this.$emit("notInViewport", this.$el.getBoundingClientRect());
            }
        },
        isInViewport() {
            const rect = this.$el.getBoundingClientRect();
            return (
                rect.top <=
                    (window.innerHeight ||
                        document.documentElement.clientHeight) &&
                rect.left >= 0 &&
                rect.bottom >= 0 &&
                rect.right <=
                    (window.innerWidth || document.documentElement.clientWidth)
            );
        },
    },
};
</script>
